import React, { Component } from "react"
import "./LidShelf.scss";

import SmallLidShelfImg from "./img/lid_shelf.svg"

class LidShelf extends Component {
    render() {
        return (
          <ul>
            <li
                id={"LidShelf_"+this.props.id}
                className="LidShelf">
                <p aria-hidden="true" className="label" style={{display:"none"}}>Lid shelf</p>
                <img src={SmallLidShelfImg} aria-label={'Cuvette seal and tube stopper shelf'} />
            </li>
          </ul>
        )
    }
}
export default LidShelf;
